export interface MaterialConsumptionFormValue {
    materialTypeDocumentId?: string
    materialDocumentId?: string
    width?: number
    amount?: number
    layerNumber?: number
}

export function getValidMaterialConsumptions(materials: MaterialConsumptionFormValue[]) {
    return (materials || []).filter(
        m => m.materialDocumentId && m.width != null && m.amount != null && m.layerNumber
    )
}
